export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
    console.log('[gatsby-browser] shouldUpdateScroll:', location.pathname);

    if (location.hash) return true;

    if (window.history.action === 'POP') {
        const saved = getSavedScrollPosition(location);

        window.scrollTo(...(saved || [0, 0]));
        return false;
    }

    window.scrollTo(0, 0);
    return false;
};
